import KundeService from '@/services/KundeService'
import _ from 'lodash'

const state = {
  items: [],
  pageCount: 1,
  totalCount: 0,
  queryParams: {
    page: 1,
    sort: 'Dato',
    direction: 'desc',
    limit: 50
  },
  loading: false,
  updating: false,
  needreload: true,
  everythingLoaded: false
}

const getters = {
  items: state => state.items,
  pageCount: state => state.pageCount,
  totalCount: state => state.totalCount,
  everythingLoaded: state => !!state.everythingLoaded,
  queryParams: state => state.queryParams,
  loading: state => !!state.loading,
  updating: state => !!state.updating,
  needreload: state => !!state.needreload
}

const actions = {
  load: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('load')

      KundeService.getKundeKontraktHistory(payload.Kundenr, payload.Kontraktnr, state.queryParams)
        .then((response) => {
          let payload = {
            items: response.data,
            pageCount: response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1,
            totalCount: response.headers['x-paging-count'] ? parseInt(response.headers['x-paging-count']) : 0
          }

          commit('success', payload)
          resolve(response)
        })
        .catch((error) => {
          commit('failure')
          reject(error)
        })
    })
  },
  reload: ({commit, dispatch}, params) => {
    commit('reload', params.queryParams || null)
    dispatch('load', {Kundenr: params.Kundenr, Kontraktnr: params.Kontraktnr})
  },
  setNeedReload: ({commit, dispatch}) => {
    commit('setNeedReload')
  }
}

const mutations = {
  load: (state) => {
    if (!state.updating) {
      state.loading = true

      state.items = []
      state.queryParams.page = 1
      state.pageCount = 0
      state.totalCount = 0
      state.everythingLoaded = false
    }
  },
  reload: (state, payload) => {
    state.updating = true

    if (payload !== null) {
      state.queryParams = payload
    }
  },
  success: (state, payload) => {
    state.loading = false
    state.updating = false

    let newItems = payload.items || []

    newItems.forEach(i => {
      if (!_.find(state.items, {Brukerloggid: i.Brukerloggid})) {
        state.items.push(i)
      }
    })

    // state.items = payload.items || []
    state.pageCount = payload.pageCount
    state.totalCount = payload.totalCount

    if (state.pageCount === state.queryParams.page) {
      state.everythingLoaded = true
    }

    state.needreload = false
  },
  failure: (state) => {
    if (state.pageCount === state.queryParams.page) {
      state.everythingLoaded = true
    }

    state.loading = false
    state.updating = false

    state.items = []
    state.pageCount = 1
    state.totalCount = 0
    state.needreload = true
  },
  setNeedReload: (state) => {
    state.needreload = true
    state.queryParams.page = 1
    state.pageCount = 1
    state.totalCount = 0
    state.items = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/kontrakthistory.js